import React, { FC, useRef } from 'react';
import './PasswordForm.css';
import {
	ActionStatusHelper,
	MessageHelper,
	Alert,
	FeedBackType,
	PageLoader,
	Toast,
	Formik,
	FormikProps,
	Form,
	PasswordField,
	FaLock,
	useAppNavigation,
	SubmitButton
} from '@/Shared';

import { PasswordFormValues, PasswordValidationSchema } from '../../Logic/UserFormValidation';
import { usePasswordForm } from '../../Logic';
import { useToast } from '@/Shared/Logic/Hooks/TechnicalHooks/useToast';

interface PasswordFormProps {

}

const PasswordForm: FC<PasswordFormProps> = () => {
	const formRef = useRef<HTMLFormElement>(null);
	const toastHook = useToast();
	const { goToForm } = useAppNavigation();
	const {
		handleSubmit,
		entityFormVM,
		formResponse,
		response,
	} = usePasswordForm(toastHook);

	const { isLoading, isFailed } = ActionStatusHelper.is(response.status);


	if (isFailed) {
		return <Alert data={{ message: response.error || MessageHelper.FETCHING.ERROR('Agent'), type: FeedBackType.ERROR }} />
	}

	if (isLoading || !entityFormVM) {
		return <PageLoader message={MessageHelper.FETCHING.LOADING('Agent')} />
	}

	return (
		<div className="PasswordForm form fade-in" data-testid="UserForm">
			<Toast data={toastHook.toastData} onClose={toastHook.closeToast} />
			<div className="form-header">
				<h3>{entityFormVM.title}</h3>
				<span className='text-center'>{entityFormVM.roleLabel}</span>
			</div>
			<Formik<PasswordFormValues>
				initialValues={entityFormVM.passwordFormValues}
				enableReinitialize={true}
				validationSchema={PasswordValidationSchema}
				onSubmit={handleSubmit}
			>

				{(formikProps: FormikProps<PasswordFormValues>) => {
					const { dirty, isValid } = formikProps;

					return (
						<Form className='form-body'>
							{
								formResponse.error &&
								<Alert data={{ message: formResponse.error || "", type: FeedBackType.ERROR }} />
							}
							<div className="fieldset-wrapper">

								<fieldset>

									<PasswordField
										required

										icon={<FaLock />}
										name='password'
										placeholder="Saisir votre mot de passe actuel"
										autoComplete='off' />

									<PasswordField
										required

										icon={<FaLock />}
										name='newPassword'
										placeholder="Saisir nouveau mot de passe"
										autoComplete='off' />

									<PasswordField
										required

										icon={<FaLock />}
										name='passwordConfirmation'
										placeholder="Saisir le même mot de passe"
										autoComplete='off' />
								</fieldset>
							</div>

							<SubmitButton
								disabled={!dirty || !isValid}
								isLoading={ActionStatusHelper.isLoading(formResponse.status)}
							/>
						</Form>);
				}}
			</Formik>


		</div>
	);
};

export default PasswordForm;